exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* CARDS */\n.card, .card-header, .list-group-item, .card-footer {\n    border-color: #e4e9f0;\n}\n\n.card-header, .card-footer {\n    background: #ffffff;\n}\n\n.card {\n    margin-bottom: 1.35rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/node_modules/postcss-loader?{"ident":"postcss"}!/Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/vendors/bootstrap/css/card.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/modules/vendors/bootstrap/css/card.css
// module chunks = styles